// src/routes.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';  // Import AuthProvider

import LoginPage from './pages/EmployeeLoginPage';
import DashboardPage from './pages/DashboardPage';
import AutoEvaluationPage from './pages/AutoEvaluationPage';
import ManualEvaluationPage from './pages/ManualEvaluationPage';
import EvaluationApproverPage from './pages/EvaluationApproverPage';
import AllOrdersPage from './pages/AllOrdersPage';
import PayoutApproverPage from './pages/PayoutApproverPage';

// Import ProtectedRoute to wrap protected routes
import ProtectedRoute from './context/ProtectedRoute';

const AppRoutes = () => {
  return (
    <AuthProvider>  {/* Wrap routes in AuthProvider */}
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<LoginPage />} />
        
        {/* Protected Routes */}
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/evaluate/:orderId/auto" 
          element={
            <ProtectedRoute>
              <AutoEvaluationPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/evaluate/:orderId/manual" 
          element={
            <ProtectedRoute>
              <ManualEvaluationPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/evaluate/:orderId/approve" 
          element={
            <ProtectedRoute>
              <EvaluationApproverPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/orders/all" 
          element={
            <ProtectedRoute>
              <AllOrdersPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/payouts" 
          element={
            <ProtectedRoute>
              <PayoutApproverPage />
            </ProtectedRoute>
          } 
        />
        
        {/* 404 Page */}
        <Route path="*" element={<div>404 - Page Not Found</div>} />
      </Routes>
    </AuthProvider>
  );
};

export default AppRoutes;
